import mapValuesToRequest from './mappers/mapValuesToRequest'
import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(provenance: string) {
    const requestBody = mapValuesToRequest(provenance)
    const response = await api.fetch('/api/v2/provenances/index', {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })

    return await handleResponse(response)
  }
}
